import { Flex } from "@chakra-ui/react"

export const NavTabs: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Flex borderBottom="1px solid" borderBottomColor="line" gap={8}>
    {children}
  </Flex>
)
